import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CenterModel } from './center.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/center';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class CenterService {
  conceptList: CenterModel[] = [];

  constructor(private http: HttpClient) {}

  getListByContact(uid: string): Promise<CenterModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<CenterModel[]>>(environment.apiUrl + LIST_ENDPOINT + '/list/' + uid)
    ).then((response) => response.data);
  }

  addData(concept: CenterModel): Promise<CenterModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<CenterModel>>(environment.apiUrl + LIST_ENDPOINT, concept)
    ).then((response) => response.data);
  }

  editData(uid: string, concept: CenterModel): Promise<CenterModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<CenterModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`, concept)
    ).then((response) => response.data);
  }

  deleteData(uid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.message);
  }

  loadData(uid: string): Promise<CenterModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<CenterModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.data);
  }
}